(function casaAccessibility(){
  'use strict';

  /* ---------- skip link ---------- */
  // The site is a single page that swaps `.view` sections, so "main content"
  // is whichever view is active — resolve it at activation time, not now.
  try {
    var skip = document.createElement('a');
    skip.className = 'casa-skip';
    skip.href = '#';
    skip.textContent = 'Skip to main content';
    skip.addEventListener('click', function(e){
      e.preventDefault();
      var v = document.querySelector('.view.active') || document.querySelector('.view');
      if (!v) return;
      v.setAttribute('tabindex','-1');
      v.focus();
      v.scrollIntoView({ block:'start' });
    });
    document.body.insertBefore(skip, document.body.firstChild);
  } catch(e){}

  /* ---------- one H1 per view ---------- */
  // view-home expresses its heading as a logo image, and view-discover and
  // view-review have none at all, so screen-reader users get no page title and
  // the document outline starts at h2 (WCAG 1.3.1, 2.4.6).
  var VIEW_H1 = {
    'view-home':     'Casa Consignment — curated pre-owned luxury',
    'view-discover': 'Newsletter — Inside Casa',
    'view-review':   'Review your consignment request'
  };
  Object.keys(VIEW_H1).forEach(function(id){
    var v = document.getElementById(id);
    if (!v || v.querySelector('h1')) return;
    var h = document.createElement('h1');
    h.className = 'casa-sr-only';
    h.textContent = VIEW_H1[id];
    v.insertBefore(h, v.firstChild);
  });

  /* ---------- the runtime pass ---------- */
  function accName(el){
    var n = el.getAttribute('aria-label')
      || el.getAttribute('title')
      || (el.labels && el.labels.length ? el.labels[0].textContent : '')
      || (el.closest('label') ? el.closest('label').textContent : '')
      || el.textContent || '';
    var by = el.getAttribute('aria-labelledby');
    if (!n.trim() && by) {
      by.split(/\s+/).forEach(function(id){
        var t = document.getElementById(id); if (t) n += ' ' + t.textContent;
      });
    }
    return n.trim();
  }

  // Guess a label for an icon-only control from what its handler does.
  function labelFromHandler(el){
    var h = el.getAttribute('onclick') || '';
    if (/closeModal|closeCart|close\(/.test(h)) return 'Close';
    if (/openCart|toggleCart/.test(h))          return 'Cart';
    if (/openSearch|toggleSearch/.test(h))      return 'Search';
    if (/openModal\(\s*['"]account/.test(h))    return 'Account';
    if (/prev/i.test(h))                        return 'Previous';
    if (/next/i.test(h))                        return 'Next';
    return '';
  }

  function pass(root){
    root = root || document;

    // 1. Icon-only controls with no accessible name.
    root.querySelectorAll('button:not([aria-label]),[role=button]:not([aria-label])').forEach(function(b){
      if (accName(b)) return;
      var l = labelFromHandler(b) || (b.className || '').toString().replace(/[-_]+/g,' ').trim();
      if (l) b.setAttribute('aria-label', l.charAt(0).toUpperCase() + l.slice(1));
    });

    // 2. Fields whose only name is a placeholder. A placeholder vanishes the
    //    moment you type, so it cannot serve as the label (WCAG 2.4.6, 3.3.2).
    root.querySelectorAll('input,select,textarea').forEach(function(f){
      if (f.type === 'hidden' || f.type === 'submit' || f.type === 'button') return;
      if (f.getAttribute('aria-label') || f.getAttribute('aria-labelledby')) return;
      if (f.labels && f.labels.length) return;
      var wrap = f.closest('label');
      if (wrap && wrap.textContent.trim()) return;
      var ph = f.getAttribute('placeholder');
      if (ph) { f.setAttribute('aria-label', ph.replace(/^e\.g\.\s*/i, '').trim() || ph); return; }
      // No placeholder either — fall back to the nearest preceding label-ish text.
      var prev = f.previousElementSibling;
      while (prev && !/^(LABEL|SPAN|H[1-6]|STRONG|DIV|P)$/.test(prev.tagName)) prev = prev.previousElementSibling;
      if (prev && prev.textContent.trim()) f.setAttribute('aria-label', prev.textContent.trim().slice(0,80));
      else if (f.type === 'range') f.setAttribute('aria-label', 'Price range');
      else if (f.type === 'file')  f.setAttribute('aria-label', 'Choose photos to upload');
    });

    // 3. Divs and spans wired with onclick. A mouse can use them; a keyboard
    //    cannot reach them at all, and a screen reader never announces them as
    //    actionable (WCAG 2.1.1, 4.1.2). Product tiles are the worst case —
    //    without this the catalogue is unusable without a mouse.
    root.querySelectorAll('[onclick]').forEach(function(el){
      var t = el.tagName;
      if (t==='BUTTON'||t==='A'||t==='INPUT'||t==='SELECT'||t==='TEXTAREA') return;
      if (el.hasAttribute('data-casa-a11y')) return;
      // Skip backdrops: their onclick only dismisses on self-click, and making
      // the overlay itself a tab stop would put a phantom control in the path.
      if (/modal-backdrop|overlay|backdrop/.test((el.className||'').toString())) return;
      el.setAttribute('data-casa-a11y','1');
      if (!el.getAttribute('role')) el.setAttribute('role','button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex','0');
      if (!accName(el)) {
        var l = labelFromHandler(el);
        if (l) el.setAttribute('aria-label', l);
      }
      el.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      });
    });

    // 4. Dialog semantics for the modals the original markup left as plain divs.
    root.querySelectorAll('.modal-backdrop').forEach(function(bd){
      var card = bd.querySelector('.modal');
      if (!card || card.getAttribute('role') === 'dialog') return;
      card.setAttribute('role','dialog');
      card.setAttribute('aria-modal','true');
      var h = card.querySelector('h1,h2,h3');
      if (h) {
        if (!h.id) h.id = 'casa-dlg-' + Math.random().toString(36).slice(2,8);
        card.setAttribute('aria-labelledby', h.id);
      }
    });

    // 5. Decorative SVGs inside labelled controls should not be announced.
    root.querySelectorAll('svg:not([aria-hidden]):not([role=img])').forEach(function(s){
      if (!s.querySelector('title')) s.setAttribute('aria-hidden','true');
    });
  }

  pass(document);

  // Re-run for injected content. Debounced: the product grid can replace
  // hundreds of nodes in one frame and a pass per mutation would jank scroll.
  var queued = false;
  try {
    new MutationObserver(function(muts){
      if (queued) return;
      var relevant = muts.some(function(m){ return m.addedNodes && m.addedNodes.length; });
      if (!relevant) return;
      queued = true;
      requestAnimationFrame(function(){ queued = false; try { pass(document); } catch(e){} });
    }).observe(document.body, { childList:true, subtree:true });
  } catch(e){}

  /* ---------- Escape closes any open modal ---------- */
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.modal-backdrop.active, .modal-backdrop.open');
    if (!open) return;
    var btn = open.querySelector('.modal-close');
    if (btn) btn.click();
  });

  /* ---------- keep focus inside an open dialog ---------- */
  // Without this, Tab walks out of the dialog and into the page behind it —
  // for a sighted keyboard user the focus ring simply disappears.
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Tab') return;
    var open = document.querySelector('.modal-backdrop.active, .modal-backdrop.open, .casa-legal-modal.open');
    if (!open) return;
    var f = open.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function(el){ return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length-1];
    if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!open.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  /* ---------- keep the footer copyright year current ---------- */
  // The footer hard-codes "© 2026". Left alone it goes stale on 1 January and
  // reads as an abandoned site — the opposite of the impression a luxury
  // storefront needs. The i18n pass parses this text with /^(© \d{4} Casa
  // Consignment\.) (.+)$/, so the replacement has to keep that exact shape.
  try {
    var fc = document.querySelector('.footer-bottom > div:first-child');
    if (fc) {
      var yr = new Date().getFullYear();
      fc.innerHTML = fc.innerHTML.replace(/©\s*(\d{4})/, function(all, y){
        return '© ' + (Number(y) >= yr ? y : y + '–' + yr);
      });
    }
  } catch(e){}

  console.log('  ✓ Accessibility pass: focus ring restored, skip link, per-view H1, keyboard-operable tiles, labelled fields, dialog semantics');
})();
